// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_dropdown__mH6-y {
  position: relative;
  width: 100%;
}

.styles_dropdownTrigger__RwRdp {
  padding: 10px 12px;
  width: 100%;
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  background-color: var(--color-white);
  color: var(--color-black);
  font: var(--typography-body-m-regular);
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 48px;
}
.styles_dropdownTrigger__RwRdp:hover {
  border-color: var(--hover-border-color, var(--color-strokes-blue));
  background-color: white;
}

.styles_dropdownValue__qg\\+8r {
  flex: 1 1;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 8px;
}

.styles_dropdownPlaceholder__zZDjh {
  color: var(--color-text-secondary);
}

.styles_dropdownArrow__GArHZ {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
}
.styles_dropdownArrow__GArHZ img {
  width: 24px;
  height: 24px;
  transition: transform 0.2s ease;
}

.styles_dropdownOpen__GIvdn .styles_dropdownArrow__GArHZ img {
  transform: rotate(180deg);
}

.styles_dropdownList__Vmd6Q {
  background-color: var(--color-white);
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  max-height: 210px;
  overflow-y: auto;
  padding: 4px;
}
.styles_dropdownList__Vmd6Q::-webkit-scrollbar {
  width: 8px;
}
.styles_dropdownList__Vmd6Q::-webkit-scrollbar-thumb {
  background: var(--color-gray-strokes);
  border-radius: 4px;
}
.styles_dropdownList__Vmd6Q::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-secondary);
}

.styles_dropdownOption__aIlUN {
  padding: 8px;
  width: 100%;
  min-height: 40px;
  border: none;
  border-radius: 12px;
  background-color: var(--color-white);
  color: var(--color-black);
  font: var(--typography-body-m-regular);
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  text-align: left;
  outline: none;
}
.styles_dropdownOption__aIlUN:hover {
  background-color: var(--hover-bg-color, var(--color-bg-light-blue));
}
.styles_dropdownOption__aIlUN.styles_dropdownOptionSelected__P4SRi {
  background-color: var(--color-blue-light);
  color: var(--color-black);
}
.styles_dropdownOption__aIlUN:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.styles_dropdownOption__aIlUN:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.styles_dropdownError__-FhCi .styles_dropdownTrigger__RwRdp {
  border-color: var(--color-error);
}
.styles_dropdownError__-FhCi .styles_dropdownTrigger__RwRdp:hover, .styles_dropdownError__-FhCi .styles_dropdownTrigger__RwRdp:focus {
  background-color: var(--color-white);
  border-color: var(--color-error);
  box-shadow: 0 0 0 3px rgba(206, 32, 33, 0.1);
}

.styles_dropdownDisabled__9ol4A .styles_dropdownTrigger__RwRdp {
  background-color: #f5f5f5;
  color: #999;
  border-color: #e0e0e0;
  cursor: not-allowed;
  opacity: 0.6;
}
.styles_dropdownDisabled__9ol4A .styles_dropdownTrigger__RwRdp:hover, .styles_dropdownDisabled__9ol4A .styles_dropdownTrigger__RwRdp:focus {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
  box-shadow: none;
}

.styles_dropdownDisabled__9ol4A .styles_dropdownArrow__GArHZ img {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/components/custom-dropdown/styles.module.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,2CAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAAF;AAEE;EACE,kEAAA;EAEA,uBAAA;AADJ;;AAKA;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,kCAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AAFJ;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,oCAAA;EACA,2CAAA;EACA,mBAAA;EACA,yCAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAHF;AAKE;EACE,UAAA;AAHJ;AAME;EACE,qCAAA;EACA,kBAAA;AAJJ;AAMI;EACE,uCAAA;AAJN;;AASA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sCAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AANF;AAQE;EACE,mEAAA;AANJ;AASE;EACE,yCAAA;EACA,yBAAA;AAPJ;AAUE;EACE,4BAAA;EACA,6BAAA;AARJ;AAWE;EACE,+BAAA;EACA,gCAAA;AATJ;;AAaA;EACE,gCAAA;AAVF;AAYE;EAEE,oCAAA;EACA,gCAAA;EACA,4CAAA;AAXJ;;AAeA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,YAAA;AAZF;AAcE;EAEE,yBAAA;EACA,qBAAA;EACA,gBAAA;AAbJ;;AAiBA;EACE,YAAA;AAdF","sourcesContent":["@import \"mixins\";\n.dropdown {\n  position: relative;\n  width: 100%;\n}\n\n.dropdownTrigger {\n  padding: 10px 12px;\n  width: 100%;\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  background-color: var(--color-white);\n  color: var(--color-black);\n  font: var(--typography-body-m-regular);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  outline: none;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 48px;\n\n  &:hover {\n    border-color: var(--hover-border-color, var(--color-strokes-blue));\n    //background-color: var(--hover-bg-color, var(--color-bg-light-blue));\n    background-color: white;\n  }\n}\n\n.dropdownValue {\n  flex: 1;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-right: 8px;\n}\n\n.dropdownPlaceholder {\n  color: var(--color-text-secondary);\n}\n\n.dropdownArrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n\n  img {\n    width: 24px;\n    height: 24px;\n    transition: transform 0.2s ease;\n  }\n}\n\n.dropdownOpen .dropdownArrow img {\n  transform: rotate(180deg);\n}\n\n.dropdownList {\n  background-color: var(--color-white);\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  max-height: 210px;\n  overflow-y: auto;\n  padding: 4px;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: var(--color-gray-strokes);\n    border-radius: 4px;\n\n    &:hover {\n      background: var(--color-text-secondary);\n    }\n  }\n}\n\n.dropdownOption {\n  padding: 8px;\n  width: 100%;\n  min-height: 40px;\n  border: none;\n  border-radius: 12px;\n  background-color: var(--color-white);\n  color: var(--color-black);\n  font: var(--typography-body-m-regular);\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  outline: none;\n\n  &:hover {\n    background-color: var(--hover-bg-color, var(--color-bg-light-blue));\n  }\n\n  &.dropdownOptionSelected {\n    background-color: var(--color-blue-light);\n    color: var(--color-black);\n  }\n\n  &:first-child {\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n  }\n\n  &:last-child {\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n  }\n}\n\n.dropdownError .dropdownTrigger {\n  border-color: var(--color-error);\n\n  &:hover,\n  &:focus {\n    background-color: var(--color-white);\n    border-color: var(--color-error);\n    box-shadow: 0 0 0 3px rgba(206, 32, 33, 0.1);\n  }\n}\n\n.dropdownDisabled .dropdownTrigger {\n  background-color: #f5f5f5;\n  color: #999;\n  border-color: #e0e0e0;\n  cursor: not-allowed;\n  opacity: 0.6;\n\n  &:hover,\n  &:focus {\n    background-color: #f5f5f5;\n    border-color: #e0e0e0;\n    box-shadow: none;\n  }\n}\n\n.dropdownDisabled .dropdownArrow img {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `styles_dropdown__mH6-y`,
	"dropdownTrigger": `styles_dropdownTrigger__RwRdp`,
	"dropdownValue": `styles_dropdownValue__qg+8r`,
	"dropdownPlaceholder": `styles_dropdownPlaceholder__zZDjh`,
	"dropdownArrow": `styles_dropdownArrow__GArHZ`,
	"dropdownOpen": `styles_dropdownOpen__GIvdn`,
	"dropdownList": `styles_dropdownList__Vmd6Q`,
	"dropdownOption": `styles_dropdownOption__aIlUN`,
	"dropdownOptionSelected": `styles_dropdownOptionSelected__P4SRi`,
	"dropdownError": `styles_dropdownError__-FhCi`,
	"dropdownDisabled": `styles_dropdownDisabled__9ol4A`
};
export default ___CSS_LOADER_EXPORT___;
